module.exports = "https://dev.stanwinstonschool.com/3-about-us-mobile.90430b1884722135f39350229ee9ad8e.jpg";